import { LoaderIcon } from "@bale/ui";
import React, { useEffect } from "react";
import { BroadcastChannel } from "broadcast-channel";
import { mavizPaymentMessage, paymentChannelName } from "utils/payment";

const FullscreenWrapperStyles = {
  width: '100vw',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

const RedirectLoader = () => {
  const channel = new BroadcastChannel(paymentChannelName);
  const query = new URLSearchParams(window.location.search);
  const messageKey = query.get("key");

  useEffect(() => {
    if (messageKey) {
      const timeout = setTimeout(window.close, 30000);
      const handleChannelMessage = ({
        key,
        url,
        close,
      }: mavizPaymentMessage) => {
        if (key === messageKey) {
          clearTimeout(timeout);
          if (url) {
            window.location.href = url;
            return;
          }
          if (close) {
            window.close();
          }
        }
      };
      channel.addEventListener("message", handleChannelMessage);

      channel.postMessage({
        key: messageKey,
        loaded: true,
      } as mavizPaymentMessage);
    }
  }, []);

  return (
    <div style={FullscreenWrapperStyles}>
      <LoaderIcon size={40}></LoaderIcon>
    </div>
  );
};
export default RedirectLoader;
